import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/forgot-password/page.tsx")